/** @format */
import { css } from 'styled-components';

import { StyledToggleFavouriteProps } from './types';

const baseStyles = () => css`
    .toggle-favourite-icon {
        display: flex;
        position: relative;
        justify-content: center;
        align-items: center;
    }
`;

// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Legacy code: do not use as an example.
export const styles = (props: StyledToggleFavouriteProps) => css`
    ${baseStyles()}
`;
